import { SortDescriptor } from "react-aria-components";

import { ModuleVersionOutputRow } from "./types";

export const sortModuleVersionOutputs = (
  outputs: ModuleVersionOutputRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return outputs;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...outputs].sort(
    (a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }) * direction
  );
};
